export default {
  traceability: {
    traceability: "tracciabilità",
    traceabilityManagement: "Gestione della trascurabilità",
    coffeeTraceabilityMngmnt: "Tracciabilità del caffè Gestione",
    traceabilityPage: "Pagina di Tracciabilità",
    labelDesigner: "Designer di etichette",
    additionalInformation: "Informazioni aggiuntive",
    coffeeInformation: "Informazioni sul caffè",
    info1:
      "Fornisci informazioni sui loghi aggiuntivi del tuo prodotto. Queste informazioni saranno disponibili per il pubblico sulla pagina di tracciabilità del caffè.",
    cropsinfo1:
      "Fornisci informazioni sui loghi aggiuntivi del tuo prodotto. Queste informazioni saranno disponibili al pubblico sulla pagina di tracciabilità.",
    addSlogan: "Aggiungi Slogan",
    sloganToolTip:
      "Aggiungi uno slogan al tuo prodotto. Queste informazioni saranno disponibili al pubblico sulla pagina di tracciabilità.",
    additionalLogos: "Logos aggiuntivi",
    title: "Titolo",
    description: "Designazione",
    mapLink: "Mappa Link",
    mapLinkTooltip: "Fornire un link mappa al prodotto.",
    originCountryTitle: "Nome Paese di origine",
    enterOriginCountryTitle: "Inserisci il nome del paese di origine",
    enterCountryDescription:
      "Fornire informazioni interessanti sul paese di origine",
    originatingCountryTooltip:
      "Fornire informazioni sul paese originario del prodotto.",
    corporativeTitle: "Nome corporativo",
    enterCorporativeTitle: "Inserisci nome corporativo",
    introDescription:
      "Ulteriori dettagli potrebbero includere informazioni di produzione, Intermediari di catena di fornitura, dettagli di trasporto, condizioni di stoccaggio, elaborazione, conformità regolamentare, ecc",
    corporativeTooltip: "Fornire informazioni sulla cooperativa.",
    coperativeDescriptionTooltip:
      "Fornire informazioni sulla cooperativa la vostra azienda è associata.",
    websiteLink: "Sito web Link",
    addMedia: "Aggiungi i media",
    uploadImageVideo: "Carica immagine/video",
    uploadImage: "Immagine di caricamento",
    origin: "Origine",
    originationCountry: "Paese di origine",
    info2:
      "Fornire informazioni sul paese originario del prodotto. Queste informazioni saranno disponibili per il pubblico sulla pagina di tracciabilità del caffè.",
    cropsinfo2:
      "Fornire informazioni sul paese originario del prodotto. Queste informazioni saranno disponibili al pubblico sulla pagina di tracciabilità.",
    countryImage: "Immagine del paese",
    traceabilityImage: "Tracciabilità Immagine",
    institutionalInfo: "Informazione cooperativa",
    info3:
      "Se la vostra azienda fa parte di una cooperativa, si prega di fornire le informazioni sulla cooperativa.",
    cooperativeLogo: "Logo cooperativo",
    traceabilityIntro: "Introduzione alla tracciabilità",
    info4:
      "Fornisci maggiori informazioni sul tracciamento e il tracciamento del tuo prodotto in tutta la sua catena di fornitura, dalla produzione o dall'origine al consumatore finale.",
    addLabel: "Aggiungi l'etichetta",
    chooseTitle: "Scegli il titolo",
    chooseLabelDesign: "Scegli il modello di design dell'etichetta",
    uploadYourLogo: "Carica il tuo logo",
    info5:
      "Istruzioni: formato immagine dovrebbe essere almeno 1000 x 1000 pixel quadrati. È possibile scegliere PNG trasparente per sincronizzare con i colori di sfondo.",
    chooseTemplateColors: "Scegli i colori dei modelli",
    backgroundColor: "Colore dello sfondo",
    foregroundColor: "Colore del primo piano",
    labelStatus: "Stato dell'etichetta",
    inactive: "Inattivo",
    download: "Scarica",
    enterLabelTitle: "Inserisci il titolo dell'etichetta",
    enableLogoProcessing: "Attiva la lavorazione del logo",
  },
  cacaoTraceability: {
    traceability: "tracciabilità",
    cacaoTraceabilityMngmnt: "Tracciabilità Cacao Gestione",
    traceabilityPage: "Pagina di Tracciabilità",
    labelDesigner: "Designer di etichette",
    additionalInformation: "Informazioni aggiuntive",
    info1:
      "Fornisci informazioni sui loghi aggiuntivi del tuo prodotto. Queste informazioni saranno disponibili per il pubblico sulla pagina di tracciabilità del cacao.",
    addSlogan: "Aggiungi Slogan",
    additionalLogos: "Logos aggiuntivi",
    title: "Titolo",
    description: "Designazione",
    mapLink: "Mappa Link",
    websiteLink: "Sito web Link",
    addMedia: "Aggiungi i media",
    uploadImageVideo: "Carica immagine/video",
    origin: "Origine",
    info2:
      "Fornire informazioni sul paese originario del prodotto. Queste informazioni saranno disponibili per il pubblico sulla pagina di tracciabilità del cacao.",
    countryImage: "Immagine del paese",
    institutionalInfo: "Informazioni istituzionali",
    info3:
      "Fornire informazioni sulla vostra azienda / cooperativa, raccontare ai consumatori circa il lavoro che state facendo. Queste informazioni saranno disponibili al pubblico sulla pagina di tracciabilità del cacao.",
    cooperativeLogo: "Logo cooperativo",
    traceabilityIntro: "Introduzione alla tracciabilità",
    info4:
      "Questa sezione darà al consumatore l'accesso all'intera produzione di caffè e alla storia della lavorazione. Descrivi l'importanza della tracciabilità alla tua azienda/cooperativa e al mondo.",
    addLabel: "Aggiungi l'etichetta",
    chooseTitle: "Scegli il titolo",
    chooseLabelDesign: "Scegli il modello di design dell'etichetta",
    uploadYourLogo: "Carica il tuo logo",
    info5:
      "Istruzioni: formato immagine dovrebbe essere almeno 1000 x 1000 pixel quadrati. È possibile scegliere PNG trasparente per sincronizzare con i colori di sfondo.",
    chooseTemplateColors: "Scegli i colori dei modelli",
    backgroundColor: "Colore dello sfondo",
    foregroundColor: "Colore del primo piano",
    labelStatus: "Stato dell'etichetta",
    inactive: "Inattivo",
    download: "Scarica",
    enterLabelTitle: "Inserisci il titolo dell'etichetta",
    originTitle: "Titolo di origine",
    corporativeTile: "Titolo Corporativo",
    enterSlogan: "Inserisci Slogan",
    enterTitle: "Inserisci il titolo",
    enterDescription: "Inserisci descrizione",
    enterMapLink: "Inserisci la mappa Link",
    enterWebsiteLink: "Inserisci il link del sito web",
  },
};
